const CategoryDetails = () => {};
export default CategoryDetails;
